// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../.npm-global/lib/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins&display=swap);"]);
// Module
exports.push([module.id, ".hi{\n    font-family:'Poppins-Regular';\n}", ""]);
// Exports
module.exports = exports;
